import { API2_HOST } from '@/utils/constants';

// const API2_HOST = 'http://local.unify-test-1.bybit.com:3007';
import fetchData from './request';
import { IBaseResponse } from './types/common';

export enum MainDeviceBindStatusCode {
  Bind = 1,
  NotBind = 2,
}

export interface MainDeviceBindStatus {
  bind_status: MainDeviceBindStatusCode;
  state: '';
  ext_info: '';
}

export interface DeleteMainDeviceParams {
  risk_token: string;
  state?: string;
  ext_info?: string;
}

export interface DeleteMaindeviceRes {
  result: boolean;
  state: string;
  ext_info: string;
}

// 获取主设备设置状态接口
export function getMainDeviceBindStatus() {
  const url = `${API2_HOST}/user/secure/primary/device/bind/status`;
  return fetchData.post<IBaseResponse<MainDeviceBindStatus>>(url);
}

// 删除主设备
export const deleteMainDeviceBind = (params: DeleteMainDeviceParams) => {
  const url = `${API2_HOST}/user/secure/primary/device/self/unbind`;
  return fetchData.post<IBaseResponse<DeleteMaindeviceRes>>(url, {
    body: JSON.stringify(params),
  });
};

export interface GetMainDeviceInfoParams {
  state?: string;
  ext_info?: string;
}

export interface IMainDeviceInfo {
  id: number; // 主键
  member_id: number; // 主账户ID
  guid: string; // app唯一id 也叫deviceid
  ip: string; // 来源ip
  ua: string; // ua信息 domain/手机ua
  platform: string; // 平台信息 ios android pc h5
  row_id: string; // 公钥唯一id 是设备guid+member_id+rsa的md5值
  device_name: string; // 设备名称
  device_type: string; // 设备类型
  device_brand: string; // 设备品牌
  site: string; // 站点信息
  domain: string; // 站点域名
  rsa_public: string; // 公钥
  salt_random: string; // 加盐随机数
  data_status: number; // 1创建成功2删除默认0
  expire_at: number; // 过期时间戳-主设备绑定的过期时间
  data_comment: string; // 评论
  created_at: string; // 创建时间
  updated_at: string; // 修改时间
}

// 获取主设备基础信息
export const getMainDeviceInfo = () => {
  const url = `${API2_HOST}/user/secure/primary/device/info`;
  return fetchData.post<IBaseResponse<{ item: IMainDeviceInfo }>>(url);
};

interface IMainDeviceAuditListParams {
  state?: string; // 功能接口标准 透传state
  ext_info?: string; // 扩展信息
  site?: string; // 功能接口标准 透传state
  cursor?: string; // 游标 这里就用 当前的认证记录的id 来作为游标
  time_stamp: string; // 时间戳 这里就用 当前的认证记录的id 来作为游标 时间段 近7天 近30天 近90天 7 30 90
}

interface IMainDeviceAuditItem {
  id: string; // 主键ID
  memberID: string; // 用户ID
  deviceID: string; // 设备ID
  ip: string; // ip
  deviceName: string; // 设备名称
  deviceType: string; // 设备类型
  deviceBrand: string; // 设备品牌
  ua: string; // ua
  risktoken: string; // risktoken
  platform: string; // 平台
  guid: string; // GUID
  auditComment: string; // 认证备注
  auditedTime: string; // 认证时间
  expire_at: string; // 设备操作系统
  created_at: string; // 设备操作系统
  updated_at: string; // 设备操作系统
  audit_status: number; // 设备操作系统审批状态 0 默认 1通过 2拒绝
  order_no: string; // 设备操作系统订单号
  location: string; // 设备操作系统位置 发起方
  created_tamp: string; // 设备操作系统创建时间戳
  ext_info: string;
  sence: string;
}

interface IMainDeviceAuditList {
  total: number; // 总条数
  state: string; // 功能接口标准 透传state
  ext_info: string; // 扩展信息
  cursor: string; // 游标 这里就用 当前的认证记录的id 来作为游标
  items: IMainDeviceAuditItem[]; // 主设备认证记录列表
}

// 获取审批历史（包含所有状态的审批）
export const getMainDeviceAuditList = (params: IMainDeviceAuditListParams) => {
  const url = `${API2_HOST}/user/secure/primary/device/auditall-list`;
  return fetchData.post<IBaseResponse<IMainDeviceAuditList>>(url, {
    body: JSON.stringify(params),
  });
};
